<div class="past-due-modal text-center">
    <div class="past-due-icon mx-auto mb-3" aria-hidden="true">!</div>

    <h2 class="modal-title head-font text-black h2-bold mb-2">
        Your account has a past-due balance
    </h2>

    <p class="amount-due mb-2">
        {{ balance | currency:'USD':'symbol':'1.2-2' }}
    </p>

    @if (showSuspensionCountdown) {
        @if (daysUntilSuspension && daysUntilSuspension > 0) {
            <p class="text-muted mb-4">
                Your account will be suspended in <strong>{{ daysUntilSuspension }}</strong>
                {{ daysUntilSuspension === 1 ? 'day' : 'days' }} unless this balance is paid in <strong>full</strong>.
            </p>
        } @else {
            <p class="text-danger mb-4">
                Your account is at risk of immediate suspension. Please pay your balance in <strong>full</strong> as soon as possible.
            </p>
        }
    } @else {
        <p class="text-muted mb-4">
            Please pay your balance in <strong>full</strong> to keep your deliveries and subscriptions running.
        </p>
    }

    <div class="d-flex flex-column flex-md-row justify-content-center gap-2 mt-3">
        <button type="button"
                class="btn btn-outline-secondary head-font h6-regular"
                (click)="dismiss()">
            Remind me later
        </button>

        <button type="button"
                class="btn btn-outline-primary head-font h6-regular"
                (click)="updatePaymentMethod()">
            Update payment method
        </button>

        <button type="button"
                class="btn btn-primary head-font h6-regular"
                (click)="viewInvoices()">
            View pending invoices
        </button>
    </div>
</div>
